import React from "react";
import cn from "classnames";
import * as styles from "./TabsV2.module.scss";
import { TypographyV2 } from "@components";

interface TabItem {
	title: string;
	icon?: React.ReactNode;
}

type TabsV2Props<T extends string> = {
	tabs: Readonly<(TabItem & { id: T })[]>;
	selectedTab: T;
	onChange: (tab: T) => void;
	wrapperClass?: string;
	tabsClassName?: string;
};

const TabsV2 = <T extends string>({
	tabs,
	selectedTab,
	onChange,
	wrapperClass,
	tabsClassName,
}: TabsV2Props<T>) => {
	return (
		<div className={cn(styles.tabsWrapper, wrapperClass)}>
			{tabs.map((tab) => (
				<div
					key={tab.id}
					className={cn(
						styles.tab,
						{
							[styles.selectedTab]: tab.id === selectedTab,
						},
						tabsClassName
					)}
					onClick={() => onChange(tab.id)}
				>
					{tab.icon && (
						<div className={styles.tabIcon}>{tab.icon}</div>
					)}
					<TypographyV2
						tabletVariant="BODY_TEXT_LARGE"
						mobileVariant="BODY_TEXT_LARGE_V2"
						weight="BOLD"
						className={styles.tabText}
						color={
							tab.id === selectedTab ? "brand-300" : "gray-400"
						}
					>
						{tab.title}
					</TypographyV2>
				</div>
			))}
		</div>
	);
};

export default TabsV2;
